var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-date-picker", {
        attrs: {
          invalid: _vm.isInvalid,
          "enable-time": true,
          placeholder: _vm.placeholder,
        },
        on: { input: _vm.onChanged },
        model: {
          value: _vm.dateTime,
          callback: function ($$v) {
            _vm.dateTime = $$v
          },
          expression: "dateTime",
        },
      }),
      _vm._v(" "),
      _vm.isInvalid
        ? _c("span", { staticClass: "text-sm text-danger" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("validation.required")) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }